<template>
  <div>
    <h1>Edit {{ activeSurvey.title }}</h1>
    <vue-form-generator
      :schema="buildSchema('survey', 'surveySchema', 'basicInfo', 'edit')"
      :model="formModel"
      :options="formOptions"
      class="vue-form-generator--admin">
    </vue-form-generator>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import editForm from '@/mixins/edit-form';

  export default {
    name: 'admin-edit-survey',
    mixins: [editForm],

    data: () => {
      return {
        formName: 'Survey',
        formIndex: 'admin-surveys',
      };
    },

    computed: {
      ...mapGetters('admin', [
        'activeSurvey',
      ]),
    },

    watch: {
      activeSurvey() {
        this.defineFormObjects();
      },
    },
  };
</script>
